/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import Link from 'next/link';
import styles from '@features/navigation/components/Navigation/Navigation.styles';
import stylesMobile from '@features/navigation/components/MegaMenuMobile/MegaMenuMobile.styles';
import { TText } from '@features/navigation/typescript';

type PropsType = {
  brand: TText;
  stores: TText;
  architects: TText;
  contact: TText;
  color: string;
  isMobile?: boolean;
  onItemClick?: () => void;
};

const BrandNavigationContent = ({
  brand,
  stores,
  architects,
  contact,
  color,
  isMobile = false,
  onItemClick = undefined,
}: PropsType) => (
  <div sx={isMobile ? stylesMobile.brandNavContainer : styles.brandNavContainer}>
    {!!brand && !!brand.link && (
      <Link href={brand.link} className="nav_top-left">
        <div sx={isMobile ? stylesMobile.brandItem : styles.brandItem(color)} onClick={onItemClick}>
          <span sx={styles.productActive(false)}>{brand.value}</span>
        </div>
      </Link>
    )}
    {!!stores && (
      <Link href={stores.link} className="nav_top-left">
        <div sx={isMobile ? stylesMobile.brandItem : styles.brandItem(color)} onClick={onItemClick}>
          <span sx={styles.productActive(false)}>{stores.value}</span>
        </div>
      </Link>
    )}
    {!!architects && (
      <Link href={architects.link} className="nav_top-left">
        <div sx={isMobile ? stylesMobile.brandItem : styles.brandItem(color)} onClick={onItemClick}>
          <span sx={styles.productActive(false)}>{architects.value}</span>
        </div>
      </Link>
    )}
    {!!contact && (
      <Link href={contact.link} className="nav_top-left">
        <div sx={isMobile ? stylesMobile.brandItem : styles.brandItem(color)} onClick={onItemClick}>
          <span sx={styles.productActive(false)}>{contact.value}</span>
        </div>
      </Link>
    )}
  </div>
);

export default BrandNavigationContent;
